import { render, staticRenderFns } from "./NovoPaciente.vue?vue&type=template&id=345043b2&scoped=true&"
import script from "./NovoPaciente.vue?vue&type=script&lang=js&"
export * from "./NovoPaciente.vue?vue&type=script&lang=js&"
import style0 from "./NovoPaciente.vue?vue&type=style&index=0&id=345043b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345043b2",
  null
  
)

export default component.exports